import GameThumb from './GameThumb.vue';

// @ts-ignore
GameThumb.install = (Vue) => {
  Vue.component((GameThumb as any).options.name, GameThumb);
};

export default GameThumb;
